import { Container, Group, Icon, IconButton, NakedButton, Table, Text, useTable } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';
import { useSubscriptionBilling } from '@melio/subscriptions-api';
import React from 'react';

export const SubscriptionBillingHistoryTable = () => {
  const { data: subscriptionBilling } = useSubscriptionBilling();
  const { formatCurrency, formatDate } = useMelioIntl();
  const { formatMessage } = useMelioIntl();

  const getStatusIcon = (status: string) => {
    switch (status) {
      default:
        return (
          <Text color="success.main">
            <Icon color="inherit" type="checked-circle" size="small" />
          </Text>
        );
    }
  };

  const tableProps = useTable({
    headerVariant: 'dark',
    data: subscriptionBilling?.history || [],
    columns: [
      {
        id: 'status',
        cell: ({ row }) => <Table.Cell>{getStatusIcon(row.status ?? '')}</Table.Cell>,
        size: 40,
      },
      {
        id: 'date',
        header: formatMessage('widgets.subscriptionBillingHistory.table.column.date'),
        cell: ({ row }) => <Table.Cell>{formatDate(row.date, { month: 'long', year: 'numeric' })}</Table.Cell>,
      },
      {
        id: 'amount',
        header: formatMessage('widgets.subscriptionBillingHistory.table.column.amount'),
        cell: ({ row }) => (
          <Table.Cell>
            <Text textStyle="body3Semi">{formatCurrency(row.amount)}</Text>
          </Table.Cell>
        ),
        size: 's',
      },
      {
        id: 'receipt',
        header: formatMessage('widgets.subscriptionBillingHistory.table.column.receipt'),
        textAlign: 'end',
        cell: () => (
          <Table.Cell textAlign="end">
            <IconButton aria-label="download recepit" icon="download" size="small" variant="naked" />
          </Table.Cell>
        ),
        size: 's',
      },
    ],
  });

  return (
    <Group variant="vertical" alignItems="flex-start" spacing="m" data-testid="subscription-billing-history">
      <Container border="regular" width="full">
        <Table {...tableProps} />
      </Container>
      <NakedButton variant="secondary" label={formatMessage('widgets.subscriptionBillingHistory.table.viewMore')} />
    </Group>
  );
};
